/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { BodyLayout } from '@veeam-vspc/shared/components';

import { ExtComponent } from '../../components/Ext/ExtComponent';

export const LicenseKeysPage: React.FC<{}> = () => {
    const xtype = 'rcop.configuration.licenseKeys.licenseKeys';

    return (
        <BodyLayout>
            <ExtComponent
                xtype={xtype}
            />
        </BodyLayout>
    );
};
